import { EInitEventTypeCode } from '@app/core/enums/init-event-type.enum';
import { IHttpError } from '@app/core/interfaces/error.interface';
import {
  IHistReactingProtocolInfo,
  IReactingProtocolStepInfoExtended,
} from '@app/core/interfaces/reacting-protocol.interface';
import {
  IInitEventDisruptionInfo,
  IInitEventDisruptionProtocolGanttInfo,
  IInitEventDisruptionProtocolHeader,
  IInitEventDisruptionPvsTask,
} from 'ngx-mt-ui-lib/api-client';
import { ISecurityEventInfo } from '@app/core/interfaces/security-events.interface';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const EventCardActions = createActionGroup({
  source: 'EVENT_CARD',
  events: {
    selectEvent: props<{ id: number; eventType: EInitEventTypeCode }>(),
    requestEventInfo: props<{ id: number; eventType: EInitEventTypeCode }>(),
    requestEventInfoSuccess: props<{
      eventInfo: ISecurityEventInfo | IInitEventDisruptionInfo;
    }>(),
    requestEventInfoError: props<{
      error: IHttpError;
    }>(),
    requestRefreshEventInfo: props<{
      id: number;
      eventType: EInitEventTypeCode;
    }>(),
    requestRefreshEventInfoSuccess: props<{
      eventInfo: ISecurityEventInfo | IInitEventDisruptionInfo;
      lastEventInfo: ISecurityEventInfo | IInitEventDisruptionInfo;
    }>(),
    requestRefreshEventInfoError: props<{
      error: IHttpError;
    }>(),
    requestEventPvsTaskList: props<{ id: number }>(),
    requestEventPvsTaskListSuccess: props<{
      eventPvsTaskList: IInitEventDisruptionPvsTask[];
    }>(),
    requestEventPvsTaskListError: props<{
      error: IHttpError;
    }>(),
    requestEventProtocols: props<{ id: number }>(),
    requestEventProtocolsSuccess: emptyProps(),
    requestEventProtocolsError: props<{
      error: IHttpError;
    }>(),
    eventCardDisruptionProtocolsSnapshot: props<{
      disruptionId: number;
      activeProtocolInfo: IInitEventDisruptionProtocolHeader | null;
      activeProtocolSteps: IReactingProtocolStepInfoExtended[];
      histProtocols: IHistReactingProtocolInfo[];
    }>(),
    requestEventActiveProtocolGantt: props<{
      eventId: number;
      protocolId: number;
      protocolLaunchDate: string;
    }>(),
    requestEventActiveProtocolGanttSuccess: props<{
      eventId: number;
      protocolId: number;
      protocolLaunchDate: string;
      gantt: IInitEventDisruptionProtocolGanttInfo;
    }>(),
    requestEventActiveProtocolGanttError: props<{
      eventId: number;
      protocolId: number;
      protocolLaunchDate: string;
      error: IHttpError;
    }>(),
    discardEventActiveProtocolGantt: props<{
      eventId: number;
      protocolId: number;
      protocolLaunchDate: string;
    }>(),
    watchEventCardReactive: props<{
      eventId: number;
      eventType: EInitEventTypeCode;
    }>(),
    stopWatchEventCardReactive: emptyProps(),
  },
});
